"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _decorators = require("decorators");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _class, _temp;

var Download = (_class = (_temp =
/*#__PURE__*/
function (_Activity) {
  babelHelpers.inherits(Download, _Activity);

  function Download() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, Download);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(Download)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    _this._downloadFile = null;
    return _this;
  }

  babelHelpers.createClass(Download, [{
    key: "setup",
    value: function setup(currentFile) {
      var _this2 = this;

      this._currentFile = currentFile;
      this.addEventListener('startActivityButtonClick', this._downloadActivityButton);
      this.addEventListener('startedActivity', this._downloadActivityStarted);
      this.addEventListener('timerExpired', function () {
        return _this2.endActivity();
      });
      this.addEventListener('endedActivity', function () {
        return _this2.activityComplete();
      });
      this.startActivity();
      if (this.readOnly) this.activityComplete();
      if (this._isEditing) this.showActivityTitle();
    }
  }, {
    key: "_downloadActivityStarted",
    value: function _downloadActivityStarted(event) {
      var _this3 = this;

      this.showActivityTitle();
      var options = {},
          download = event.activity.details.Document;
      var promise;

      if ('activityId' in download) {
        promise = (0, _fetch.default)("access/".concat(download.activityId)).then(function (data) {
          return data.json();
        });
      } else {
        promise = Promise.resolve({
          access: 'enabled',
          detail: {
            signedDocumentURL: download.file
          }
        });
      }

      promise.then(function (access) {
        _this3.showStartActivityButton('document-button');

        _this3.$('#document-button').removeAttr('data-spin');

        _this3._downloadFile = access.detail.signedDocumentURL;

        if (!_this3.readOnly) {
          if (event.activity.endTime) {
            _this3.startTimer(new Date(event.activity.endTime).getTime() - new Date(event.activity.startTime).getTime(), true);
          } else {
            _this3.startTimer(10 * 1000, true);
          }
        }
      });
    }
  }, {
    key: "_downloadActivityButton",
    value: function _downloadActivityButton(event) {
      if (this._downloadFile) {
        window.open(this._downloadFile, '_blank');
        if (!this.readOnly) this.startActivity();
      }
    }
  }]);
  return Download;
}(_base.default), _temp), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "_downloadActivityStarted", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_downloadActivityStarted"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_downloadActivityButton", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_downloadActivityButton"), _class.prototype)), _class);
exports.default = Download;